export default "__VITE_ASSET__W8v15oYq__"